/**
 * Created by PanJiaChen on 16/11/18.
 */

import localFun from '@/utils/local-ope';

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/');
      }
    }

    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */

export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

export const getExtName = (filename) => {
  if (!filename || typeof filename != 'string') {
    return '';
  }

  const reverseStr = filename.split('').reverse().join('');
  return reverseStr
    .substring(0, reverseStr.search(/\./))
    .split('')
    .reverse()
    .join('')
    .toLowerCase();
};
/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return '';
  return cleanArray(
    Object.keys(json).map((key) => {
      if (json[key] === undefined) return '';
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
    })
  ).join('&');
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ');
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split('&');
  searchArr.forEach((v) => {
    const index = v.indexOf('=');
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (argsTwo) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, argsTwo);
      context = argsTwo = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + '';
  const randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}

/**
 * Get browser type
 * @returns {object} ret
 */
export function getBrowser() {
  const ua = window.navigator.userAgent;

  const ret = {},
    webkit = ua.match(/WebKit\/([\d.]+)/),
    chrome = ua.match(/Chrome\/([\d.]+)/),
    edge = ua.match(/Edg\/([\d.]+)/) || ua.match(/Edge\/([\d.]+)/),
    ie =
      ua.match(/MSIE\s([\d\.]+)/) || ua.match(/(?:trident)(?:.*rv:([\w.]+))?/i),
    firefox = ua.match(/Firefox\/([\d.]+)/),
    safari = ua.match(/Safari\/([\d.]+)/),
    opera = ua.match(/OPR\/([\d.]+)/);

  webkit && (ret.webkit = parseFloat(webkit[1]));
  chrome && (ret.chrome = parseFloat(chrome[1]));
  edge && (ret.edge = parseFloat(edge[1]));
  ie && (ret.ie = parseFloat(ie[1]));
  firefox && (ret.firefox = parseFloat(firefox[1]));
  safari && (ret.safari = parseFloat(safari[1]));
  opera && (ret.opera = parseFloat(opera[1]));
  ret.weixin = window.__wxjs_environment === 'miniprogram';
  return ret;
}

const hasOwnProperty = Object.prototype.hasOwnProperty;
export const hasOwn = (val, key) => hasOwnProperty.call(val, key);

export function getUserAgent() {
  let browserReg = {
    Chrome: /Chrome/,
    IE: /MSIE/,
    Firefox: /Firefox/,
    Opera: /Presto/,
    Safari: /Version\/([\d.]+).*Safari/,
    Edge: /Edg/
  };
  let deviceReg = {
    iPhone: /iPhone/,
    iPad: /iPad/,
    Android: /Android/,
    Windows: /Windows/,
    Mac: /Macintosh/
  };
  let userAgentStr = navigator.userAgent;
  const userAgentObj = {
    browserName: '', // 浏览器名称
    browserVersion: '', // 浏览器版本
    osName: '', // 操作系统名称
    osVersion: '', // 操作系统版本
    deviceName: '' // 设备名称
  };
  for (let key in browserReg) {
    if (browserReg[key].test(userAgentStr)) {
      userAgentObj.browserName = key;
      if (key === 'Chrome') {
        userAgentObj.browserVersion = userAgentStr
          ?.split('Chrome/')[1]
          ?.split(' ')[0];
      } else if (key === 'IE') {
        userAgentObj.browserVersion = userAgentStr
          ?.split('MSIE ')[1]
          ?.split(' ')[1];
      } else if (key === 'Firefox') {
        userAgentObj.browserVersion = userAgentStr?.split('Firefox/')[1];
      } else if (key === 'Opera') {
        userAgentObj.browserVersion = userAgentStr?.split('Version/')[1];
      } else if (key === 'Safari') {
        userAgentObj.browserVersion = userAgentStr
          ?.split('Version/')[1]
          ?.split(' ')[0];
      } else if (key === 'Edge') {
        userAgentObj.browserVersion = userAgentStr
          ?.split('Edg/')[1]
          ?.split(' ')[0];
      }
    }
  }

  for (let key in deviceReg) {
    if (deviceReg[key].test(userAgentStr)) {
      userAgentObj.osName = key;
      if (key === 'Windows') {
        userAgentObj.osVersion = userAgentStr
          .split('Windows NT ')[1]
          .split(';')[0];
      } else if (key === 'Mac') {
        userAgentObj.osVersion = userAgentStr
          .split('Mac OS X ')[1]
          .split(')')[0];
      } else if (key === 'iPhone') {
        userAgentObj.osVersion = userAgentStr
          .split('iPhone OS ')[1]
          .split(' ')[0];
      } else if (key === 'iPad') {
        userAgentObj.osVersion = userAgentStr
          .split('iPad; CPU OS ')[1]
          .split(' ')[0];
      } else if (key === 'Android') {
        userAgentObj.osVersion = userAgentStr
          .split('Android ')[1]
          .split(';')[0];
        // userAgentObj.deviceName = userAgentStr
        //   .split('(Linux; Android ')[1]
        //   .split('; ')[1]
        //   .split(' Build')[0];
      }
      userAgentObj.deviceName = key;
    }
  }
  return userAgentObj;
}

/**
 * 逻辑复用 - 常规请求处理
 */
export function handleRequestError(fn, finallyFn) {
  return function (...args) {
    try {
      fn.call(this, ...args);
    } catch (error) {
      this.Sentry.captureException(error);
    } finally {
      finallyFn && finallyFn.call(this);
    }
  };
}

/**
 * @description: 判断是否为空
 * @param {*} obj
 * @returns
 */
export function IsEmpty(obj) {
  if (typeof obj === 'string') return obj.length === 0;
  if (typeof obj === 'number') return false;
  // null 、 undefined 为空
  if (obj == null || obj == undefined) return true;
  // 如果它是一个对象，它不是一个数组，它没有任何属性，那么它是空的
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;
  // 如果它不是一个对象
  // 它是空的，但它不能是任何东西
  if (typeof obj !== 'object') return true;
  // 如果它是一个对象，它不是一个数组，它没有任何属性，那么它是空的
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) return false;
  }

  if (Object.keys(obj).length === 0) {
    return true;
  }

  return true;
}
export function deepClone(obj) {
  // 检查是否是基本数据类型或null
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  // 处理日期和正则表达式
  if (obj instanceof Date) {
    return new Date(obj);
  }
  if (obj instanceof RegExp) {
    return new RegExp(obj.source, obj.flags);
  }

  // 创建一个新对象或数组
  const cloneObj = new obj.constructor();

  // 循环复制属性
  Object.keys(obj).forEach((key) => {
    const val = obj[key];
    cloneObj[key] = deepClone(val); // 递归复制属性值
  });

  return cloneObj;
}

/**
 * 判断是否需要变更页码
 * 删除后数量小于当前page*pageSize，删除前数量大于当前page*pageSize，
 * 返回是否需要变更页码，以及变更后的页码
 */
export function isPageChange(page, pageSize, total) {
  // 当前页码都是1了肯定不用退回0啊（因为目前大多数都是删除之后引起的页码变化）
  if (page === 1) {
    return [false, 1];
  }

  // 计算最大页码
  const maxPage = Math.ceil(total / pageSize);

  // 如果当前页码大于最大页码，说明需要调整
  if (page > maxPage) {
    return [true, maxPage];
  }

  // 如果当前页码在有效范围内，不需要调整
  return [false, page];
}

/**
 * 应用别名到组织类型标签
 * @param {Array} orgTypeList - 组织类型列表
 * @param {Object} tabsAlias - 别名配置对象
 * @returns {Array} 应用别名后的组织类型列表
 */
export function applyOrgTypeAlias(orgTypeList, tabsAlias = {}) {
  return orgTypeList.map((item) => {
    const alias = tabsAlias[item.id];
    return {
      ...item,
      label: alias && alias.trim() ? alias : item.label
    };
  });
}

//根据大后台租户配置 计算出tab展示项 deleteTab需要删除的tab,就是配置了也不展示;
export function formatOrgType(deleteTab = []) {
  //兼容发完版本 但是用户未重新登录时 极端情况
  const defaultConfig = JSON.stringify({
    COMPETENT_AUTHORITY: true,
    DEALER: true,
    HOSPITAL: true,
    PHARMACY: true
  });
  const defaultAlias = JSON.stringify({
    HOSPITAL: '',
    DEALER: '',
    COMPETENT_AUTHORITY: '',
    PHARMACY: ''
  });

  const tabs = JSON.parse(localFun.get('myOrgTab') || defaultConfig);
  const tabsAlias = JSON.parse(localFun.get('myOrgTabAlias') || defaultAlias);

  const orgTypeList = [
    {
      id: 'HOSPITAL',
      label: '医院'
    },
    {
      id: 'DEALER',
      label: '经销商'
    },
    {
      id: 'COMPETENT_AUTHORITY',
      label: '主管单位'
    },
    {
      id: 'PHARMACY',
      label: '药店'
    }
  ];

  const filterList = orgTypeList.filter((item) => {
    return tabs[item.id] && !deleteTab.includes(item.id);
  });

  // 应用别名配置
  return applyOrgTypeAlias(filterList, tabsAlias);
}

/**
 * 获取应用别名后的机构类型名称（用于智能替换）
 * @param {string} orgId 机构ID（如：'HOSPITAL'、'DEALER'等）
 * @param {string} originalName 原始名称（如：'医院客户'、'医院'等）
 * @returns {string} 应用别名后的名称
 */
export function getOrgTypeWithAlias(orgId, originalName) {
  try {
    // 读取别名配置
    const aliasConfig = JSON.parse(localFun.get('myOrgTabAlias') || '{}');

    // 如果没有别名配置或该机构类型没有别名，返回原始名称
    if (!aliasConfig || !aliasConfig[orgId]) {
      return originalName;
    }

    const alias = aliasConfig[orgId];

    // 如果别名为空或只包含空格，返回原始名称
    if (!alias || !alias.trim()) {
      return originalName;
    }

    // 机构类型映射表
    const orgTypeMap = {
      HOSPITAL: '医院',
      DEALER: '经销商',
      COMPETENT_AUTHORITY: '主管单位',
      PHARMACY: '药店'
    };

    const orgTypeName = orgTypeMap[orgId];

    if (orgTypeName) {
      // 情况1: "医院客户" -> "医院别名客户"
      if (originalName.includes(orgTypeName + '客户')) {
        return originalName.replace(orgTypeName + '客户', alias + '客户');
      }
      // 情况2: "医院" -> "医院别名"
      else if (originalName === orgTypeName) {
        return alias;
      }
      // 其他情况：包含机构类型名称的，都替换为别名
      else if (originalName.includes(orgTypeName)) {
        return originalName.replace(orgTypeName, alias);
      }
    }

    return originalName;
  } catch (error) {
    console.warn('读取机构别名配置失败，使用默认名称:', error);
    return originalName;
  }
}
